import React from 'react';
import PropTypes from 'prop-types';
import {
  withGoogleMap,
  GoogleMap,
  OverlayView,
  Marker
} from 'react-google-maps';
import withScriptjs from 'react-google-maps/lib/async/withScriptjs';

import config from '../../config';

const DEFAULT_CENTER = { lat: 41.387668, lng: 2.172583 };

export const AsyncGoogleMap = withScriptjs(withGoogleMap((props) => (
  <GoogleMap
    zoom={props.zoom}
    center={props.center || DEFAULT_CENTER}
    options={{
      clickableIcons: false,
      mapTypeControl: false
    }}
  >
    {props.children}
  </GoogleMap>
)));

const getPixelPositionOffset = (width, height) => ({
  x: -(width / 2),
  y: -height - 4
});

const MapWithMarkers = ({
  markers,
  center,
  zoom
}) => {
  const mapCenter = center || markers[0].position;
  const mapZoom = zoom || 12;

  return (
    <div className="map-container">
      <AsyncGoogleMap
        googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&key=${config.GOOGLE_MAP_API_KEY}`}
        loadingElement={<div style={{ height: 500 }} />}
        containerElement={<div style={{ height: 500 }} />}
        mapElement={<div style={{ height: 500 }} />}
        center={mapCenter}
        zoom={mapZoom}
      >
        {markers.map(({ position, info }) => {
          const key = `${position.lat}${position.lng}`;

          if (!info) {
            return (
              <Marker
                key={key}
                position={position}
              />
            );
          }

          return (
            <OverlayView
              key={key}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
              position={position}
              getPixelPositionOffset={getPixelPositionOffset}
            >
              <div className="custom-map-marker">
                {info}
              </div>
            </OverlayView>
          );
        })}
      </AsyncGoogleMap>
    </div>
  );
};

MapWithMarkers.propTypes = {
  center: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number
  }),
  markers: PropTypes.arrayOf(PropTypes.shape({
    position: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number
    })
  })).isRequired,
  zoom: PropTypes.number
};

MapWithMarkers.defaultProps = {
  markers: [],
  zoom: 12
};

export default MapWithMarkers;



// WEBPACK FOOTER //
// ./src/widgets/MapWithMarkers/index.js